<app-blade-header [bladeIndex]="bladeIndex">
  @if (title$ | async; as title) {
    <ng-container title>
      {{title}}
    </ng-container>
  }
</app-blade-header>

@if ((activityPointListItems$ | async); as activityPointListItems) {
  @if (activityPointListItems && activityPointListItems.length > 0) {
    <div class="vehicle-trip-info">
      <div class="header">
        <div class="text" translate>
          Stop
        </div>
      </div>
      <div class="items">
        @for (item of activityPointListItems; track trackByIndex(index, item); let index = $index) {
          <div class="item" [class.selected]="(isSelectedCall$(item.activityPoint?.stopId) | async)" [class.departed]="item.hasDeparted" [class.timing-point]="item.activityPoint?.isTimingPoint" (click)="itemSelected(item)">
            <div class="stop-description">
              {{item.activityPoint?.stopDescription}}
              @if (item.activityPoint?.platformCode) {
                ({{ item.activityPoint?.platformCode }})
              }
            </div>
            <div class="departure">
              @if (item.activityPoint?.isTimingPoint) {
                <i class="far fa-clock"></i>
              }
              {{item.activityPoint?.departureTime}}
            </div>
          </div>
        }
      </div>
    </div>
  }
}